var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-aside",
    {
      class: [_vm.menu.collapse ? "" : "aside-uncollapse"],
      attrs: { width: _vm.menu.collapse ? "88px" : "220px" },
    },
    [
      !_vm.$store.state.menu.collapse && !_vm.param.only
        ? _c(
            "Tabs",
            {
              staticClass: "tab-switch",
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: {
                  label: _vm.$t("dashboard-bi::board-management::公共看板"),
                  name: "1",
                  disabled: !_vm.$auth("data-board-customer::show-list"),
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: _vm.$t("dashboard-bi::board-management::个人看板"),
                  name: "2",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$store.state.menu.collapse,
              expression: "$store.state.menu.collapse",
            },
          ],
          staticClass: "collapse-switch",
        },
        [
          _c("div", { staticClass: "switch-wrapper" }, [
            _c(
              "div",
              {
                staticClass: "switch-dot",
                class: _vm.activeTab == "2" ? "change" : "",
                on: { click: _vm.changeSwitch },
              },
              [_c("span", [_vm._v(" " + _vm._s(_vm.collapseName) + " ")])]
            ),
          ]),
        ]
      ),
      _c(
        "ScrollsBar",
        {
          staticClass: "menuList",
          style: { height: _vm.$store.state.menu.collapse ? "100%" : "" },
        },
        [
          !_vm.boardMenuLoading
            ? [
                _vm.newMenus.length
                  ? _c("div", { staticClass: "aside-padding" }, [
                      _c(
                        "div",
                        { staticClass: "menu-box" },
                        [
                          _c(
                            "el-menu",
                            {
                              attrs: {
                                collapse: _vm.menu.collapse,
                                "collapse-transition": false,
                                "default-active": _vm.defaultRoute,
                                "active-text-color": "#0560fd",
                                "background-color": "#fafbff",
                                "text-color": "#5E6471",
                                "unique-opened": "",
                              },
                              on: { select: _vm.handleSelect },
                            },
                            [
                              _vm._l(_vm.newMenus, function (menuData) {
                                return [
                                  _c("my-menu-item", {
                                    key: menuData.name,
                                    attrs: {
                                      item: menuData,
                                      translate: function (key) {
                                        return _vm.$t(key)
                                      },
                                    },
                                  }),
                                ]
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ])
                  : !_vm.$store.state.menu.collapse
                  ? _c("ZDefaultData", {
                      staticClass: "menu-empty",
                      attrs: {
                        custom: {
                          text: _vm.$t("system::common::text::board_empty"),
                          buttons: _vm.emptyButton,
                        },
                      },
                    })
                  : _vm._e(),
              ]
            : [
                _c("div", {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: true,
                      expression: "true",
                    },
                  ],
                  staticStyle: { height: "200px" },
                }),
              ],
        ],
        2
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.param.only && (_vm.showBoardHandle || !_vm.disabled),
              expression: "!param.only && (showBoardHandle || !disabled)",
            },
          ],
          staticClass: "menu-button-group",
          class: { "collapse-menu-button": _vm.$store.state.menu.collapse },
        },
        [
          _vm.showBoardHandle && !_vm.$store.state.menu.collapse
            ? [
                (
                  _vm.activeTab === "1"
                    ? _vm.$auth("data-board-customer::addMenu")
                    : true
                )
                  ? _c(
                      "el-button-group",
                      {
                        class: [!!_vm.disabled ? "no-menu" : ""],
                        staticStyle: { flex: "1" },
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t(
                                "system::common::btn::新增目录/菜单"
                              ),
                              effect: "dark",
                              placement: "top-start",
                            },
                          },
                          [
                            (
                              _vm.activeTab === "1"
                                ? _vm.$auth("data-board-customer::addMenu")
                                : true
                            )
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "menu-button",
                                    staticStyle: { width: "50%" },
                                    attrs: {
                                      plain: "",
                                      size: "medium",
                                      type: "info",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.visible = true
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "24px",
                                        display: "inline-block",
                                      },
                                      attrs: { src: _vm.icon.add },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t("system::common::btn::菜单管理"),
                              effect: "dark",
                              placement: "top-start",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "menu-button",
                                staticStyle: { width: "50%" },
                                attrs: {
                                  plain: "",
                                  size: "medium",
                                  type: "info",
                                },
                                on: { click: _vm.toSetting },
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "24px",
                                    display: "inline-block",
                                  },
                                  attrs: { src: _vm.icon.board },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          content: _vm.$t("system::common::btn::菜单管理"),
                          effect: "dark",
                          placement: "top-start",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "menu-button",
                            staticStyle: { flex: "1" },
                            attrs: { plain: "", size: "medium", type: "info" },
                            on: { click: _vm.toSetting },
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                width: "24px",
                                display: "inline-block",
                              },
                              attrs: { src: _vm.icon.board },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
              ]
            : _vm._e(),
          _c("HandleMenu", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.disabled,
                expression: "!disabled",
              },
            ],
            attrs: {
              menuList: _vm.handleMenuList,
              showBoardHandle: _vm.showBoardHandle,
            },
          }),
        ],
        2
      ),
      !_vm.menu.collapse &&
      _vm.user.combo.isTrial &&
      _vm.user.combo.isTrial === 1 &&
      !_vm.user.isExpired &&
      !_vm.user.combo.isThird
        ? _c("div", { staticClass: "combo-wrap" }, [
            _c("div", { staticClass: "combo-title" }, [
              _c("p", { staticClass: "one-line" }, [
                _vm._v(_vm._s(_vm.user.combo.comboName)),
              ]),
              _c("span", [_vm._v(_vm._s(_vm.$t("personal::common::试用版")))]),
            ]),
            _c("div", { staticClass: "combo-date" }, [
              _c("div", { staticClass: "combo-day" }, [
                _vm.user.combo.comboExpireDay > 0
                  ? _c("p", { staticStyle: { "font-size": "36px" } }, [
                      _vm._v(" " + _vm._s(_vm.user.combo.comboExpireDay) + " "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("personal::common::天"))),
                      ]),
                    ])
                  : _c("span", [
                      _vm._v(_vm._s(_vm.$t("personal::common::今天到期"))),
                    ]),
              ]),
              _c("a", { staticClass: "combo-buy", on: { click: _vm.buyNow } }, [
                _vm._v(_vm._s(_vm.$t("personal::common::立即购买"))),
              ]),
            ]),
          ])
        : _vm._e(),
      _c("AddOrUpdate", {
        attrs: { editRow: { type: "add" }, routerType: Number(_vm.activeTab) },
        model: {
          value: _vm.visible,
          callback: function ($$v) {
            _vm.visible = $$v
          },
          expression: "visible",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }